//tslint:disable

import React, { useState, useEffect } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Editor } from '@tinymce/tinymce-react';
import AutosizeInput from 'react-input-autosize';
import axios from "axios";

const DragAndDropWord = ({ course, topic, lesson, dragDropInfo, edit }) => {
  const [word, setWord] = useState('');
  const [isError, setError] = useState(false);
  const [isErrorWord, setErrorWord] = useState(false);
  const [kind, setKind] = useState('word_sequence');
  const [question, setQuestion] = useState(dragDropInfo ? dragDropInfo.question : '');
  const [cond_description, setDescription] = useState(dragDropInfo ? dragDropInfo.cond_description : '');
  const [explanation, setExplanation] = useState(dragDropInfo ? dragDropInfo.explanation : '');
  const [tip, setTip] = useState(dragDropInfo ? dragDropInfo.tip : '');
  const [priority, setPriority] = useState(dragDropInfo ? dragDropInfo.priority : '');
  const [difficulty, setDifficulty] = useState(dragDropInfo ? dragDropInfo.difficulty : '');
  const [dragDropList, setDragDropList] = useState(dragDropInfo ? dragDropInfo.variants.initial_array_variants : []);
  const [dragDropListResult, setDragDropListResult] = useState(dragDropInfo ? dragDropInfo.variants.initial_array_answers : []);

  const onDragComplete = (result) => {
    if (!result.destination) return;

    const arr = [...dragDropList];

    const removedItem = arr.splice(result.source.index, 1)[0];
    arr.splice(result.destination.index, 0, removedItem);

    setDragDropList(arr);
  };

  const onDragCompleteResult = (result) => {
    if (!result.destination) return;

    const arr = [...dragDropListResult];

    const removedItem = arr.splice(result.source.index, 1)[0];
    arr.splice(result.destination.index, 0, removedItem);

    setDragDropListResult(arr);
  };

  const addWord = () => {
    if (!word || dragDropList.length > 5) return;

    const drag = dragDropList.find((item) => item.label === word);

    if (!drag) {
      const id = dragDropList.length ? dragDropList[dragDropList.length - 1].id + 1 : dragDropList.length + 1;
      setDragDropList([...dragDropList, { id, label: word }]);
      setDragDropListResult([...dragDropListResult, { id, label: word }]);
      setWord('');
    }
  }

  const deleteWord = (item, index) => {
    const arr = [...dragDropList];
    const arrResult = [...dragDropListResult];

    const indexResult = dragDropListResult.findIndex((drop) => drop.id === item.id)

    arr.splice(index, 1);
    arrResult.splice(indexResult, 1);

    setDragDropList(arr);
    setDragDropListResult(arrResult);
  }

  const changeInput = (item, index) => (e) => {
    let arr = [...dragDropList];
    let arrResult = [...dragDropListResult];

    const indexResult = dragDropListResult.findIndex((drop) => drop.id === item.id);

    arr[index].label = e.target.value;
    arrResult[indexResult].label = e.target.value;

    setDragDropList(arr);
    setDragDropListResult(arrResult);
  }

  useEffect(() => {
    const isCheckWord = dragDropList.filter(item => item.label === '')
    if (isCheckWord.length) {
      setErrorWord(true)
    } else {
      setErrorWord(false)
    }
  }, [dragDropList])

  const handleSubmit = (ev) => {
    ev.preventDefault();
    const result = {
      course_drag_and_drop: {
        kind,
        variants: {
          array_variants: dragDropList.map(item => item.label),
          answer: dragDropListResult.map(item => item.label).join(' '),
          initial_array_variants: dragDropList,
          initial_array_answers: dragDropListResult,
        },
        question,
        explanation,
        tip,
        difficulty,
        cond_description,
        priority
      }
    }

    if (question === '' || difficulty === '' || dragDropList.length === 0 || priority === '') {
      setError(true);
    } else {
      setError(false);
    }

    if (question !== '' && difficulty !== '' && dragDropList.length !== 0 && !isErrorWord && priority !== '') {
      if (edit) {
        axios
          .patch(
            `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}/drag_and_drops/${dragDropInfo.id}`,
            result,
            {
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
              },
            }
          ).then(() => {
            location.href = `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}#drag_and_drops`
          })
          .catch((e) => {
            console.log(e.message)
          });
      } else {
        axios
          .post(
            `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}/drag_and_drops`,
            result,
            {
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
              },
            }
          ).then(() => {
            location.href = `/backend/admin/courses/${course.id}/topics/${topic.id}/lessons/${lesson.id}#drag_and_drops`
          })
          .catch((e) => {
            console.log(e)
          });
      }
    }
  };

  return (
    <form className="modal-form" onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
      <div className="form-group string required">
        <label className="control-label string required" htmlFor="question">
          <abbr title="required">*</abbr>
            Вопрос
        </label>
        <Editor
          apiKey='kxcwvdfzs45kp41l80l8lqp32lhery31i1sqi88mjxynx1ur'
          onEditorChange={(e => setQuestion(e))}
          value={question}
          init={{
            height: 200,
            menubar: true,
            plugins: [
              'autolink lists link image charmap print preview',
              'searchreplace visualblocks code',
              'media table paste code help'
            ],
            toolbar: 'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
          }}
        />
      </div>
      <div className="form-group text">
        <label className="control-label text" htmlFor="cond_description">
          Условия задания
        </label>
        <Editor
          apiKey='kxcwvdfzs45kp41l80l8lqp32lhery31i1sqi88mjxynx1ur'
          onEditorChange={(e => setDescription(e))}
          value={cond_description}
          init={{
            height: 200,
            menubar: true,
            toolbar: 'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
          }}
        />
      </div>
      <div className="form-group text">
        <label className="control-label text" htmlFor="tip">
          Подсказка
        </label>
        <textarea className="form-control text" defaultValue={tip} onChange={(e) => setTip(e.target.value)} id="tip" />
      </div>
      <div className="form-group text">
        <label className="control-label text" htmlFor="explanation">
          Решение
        </label>
        <Editor
          apiKey='kxcwvdfzs45kp41l80l8lqp32lhery31i1sqi88mjxynx1ur'
          onEditorChange={(e => setExplanation(e))}
          value={explanation}
          init={{
            height: 200,
            menubar: true,
            toolbar: 'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
          }}
        />
      </div>
      <div className="form-group text">
        <label className="control-label text" htmlFor="priority">
          <abbr title="required">*</abbr>
          Приоритет
        </label>
        <input className="form-control text" defaultValue={priority} onChange={(e) => setPriority(e.target.value)} id="priority" />
      </div>
      <div className="form-group select">
        <label className="control-label select" htmlFor="difficulty">
          <abbr title="required">*</abbr>
          Сложность
        </label>
        <select className="form-control select" defaultValue={difficulty} onChange={(e) => setDifficulty(e.target.value)} id="difficulty">
          <option selected value=""></option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
      </div>
      <div className="row">
        <div className="col">
          <div className="form-group integer">
            <label className="control-label integer" htmlFor="addWord">
              <abbr title="required">*</abbr>
              Добавить слово
            </label>
            <input
              className="form-control numeric integer"
              type={'text'}
              id="addWord"
              maxLength={20}
              value={word}
              onInput={(e) => setWord(e.target.value)}
            />
          </div>
        </div>
        <div className="col">
          <button name="button" type="button" className="btn btn-default mtl-2 btn btn-outline-primary" onClick={addWord}>Добавить</button>
        </div>
      </div>
      {dragDropList.length > 0 && <div className="titleList">Массив слов:</div>}
      <DragDropContext onDragEnd={onDragComplete}>
        <Droppable droppableId="drag-drop-list" direction="horizontal">
          {(provided) => (
            <div
              className='dragDropListContainer'
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {dragDropList.map((item, index) => (
                <Draggable key={item.id} draggableId={item.label} index={index}>
                  {(provided) => (
                    <div
                      className='item-container'
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <div className='item'>
                        <span className='itemDelete' onClick={() => deleteWord(item, index)} />
                        <AutosizeInput
                          className={'itemInput'}
                          type={'text'}
                          defaultValue={item.label}
                          maxlength={20}
                          onChange={changeInput(item, index)}
                        />
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      {dragDropListResult.length > 0 && <div className="titleListResult">Правильная комбинация слов:</div>}
      <DragDropContext onDragEnd={onDragCompleteResult}>
        <Droppable droppableId="drag-drop-list-result" direction="horizontal">
          {(provided) => (
            <div
              className='dragDropListContainer'
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {dragDropListResult.map((item, index) => (
                <Draggable key={item.id} draggableId={item.label} index={index}>
                  {(provided) => (
                    <div
                      className='item-container'
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <div className='item'>
                        <p className='label'>{item.label}</p>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      {isError && <div className="error">Заполните все обязательные поля</div>}
      {isErrorWord && <div className="error">Слово не может быть пустым</div>}
      <button type="submit" className="btn btn-default mtl-2 btn btn-outline-success">
        Отправить
      </button>
    </form>
  );
}

export default React.memo(DragAndDropWord);


// WEBPACK FOOTER //
// ./app/frontend/components/DragAndDropWord.js